module.exports = __webpack_public_path__ + "static/media/3.fc43ca89.jpg";